import React from "react"; 
import Pagination from "react-bootstrap/Pagination"; 
import { PaginationModel } from "../interfaces";
import { CustomLabel, FlexContainer, PaginationWrapper } from "../styles";
import SingleSelect from "./SingleSelect";

type IProps = {
  pagination: PaginationModel;
  className?: string;
  onPageChange?: (pageNumber: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
};
export default class TablePagination extends React.Component<IProps> {
  get pagination() {
      return this.props.pagination;
  }
  get options() {
      return [10, 25, 50, 100, 200, 500].map((page) => {
          return { value: page, label: page };
      });
  }

  generatePageNumbers = (
      currentPage: number,
      pageSize: number,
      maxPagesToShow: number,
      totalItems: number,
  ): number[] => {
      const totalNumbers = maxPagesToShow; // Total page numbers to show at a time
      const totalBlocks = Math.ceil(totalNumbers / 2); // Half before the current page, half after

      let startPage = Math.max(1, currentPage - totalBlocks);
      let endPage = Math.min(startPage + totalNumbers - 1, Math.ceil(totalItems / pageSize)); // Assuming 500 is the total number of items

      // Adjust the range if we're at the start or end
      if (currentPage < totalBlocks) {
          endPage = totalNumbers;
      } else if (currentPage > totalItems / pageSize - totalBlocks) {
          startPage = Math.ceil(totalItems / pageSize) - totalNumbers + 1;
      }

      // Generate the array of page numbers
      const range = (start: number, end: number): number[] => {
          return Array.from({ length: end - start + 1 }, (_, i) => start + i);
      };

      return range(startPage, endPage);
  };

  get paginationNumbering() {
      const pages = this.pagination.pageCount > 5 ? 5 : this.pagination.pageCount;
      return (
          <>
              {this.generatePageNumbers(
                  this.pagination.pageNumber,
                  this.pagination.pageSize,
                  pages,
                  this.pagination.totalItemCount,
              ).map((page) => {
                  return (
                      <>
                          <Pagination.Item
                              key={page}
                              onClick={() => this.props.onPageChange && this.props.onPageChange(page)}
                              active={page === this.pagination.pageNumber}
                          >
                              {' '}
                              {page}
                          </Pagination.Item>
                      </>
                  );
              })}
          </>
      );
  }

  get previous() {
      const disabled = this.pagination.pageCount <= 0 || this.pagination.pageNumber === 1;
      const previousPage = this.pagination.pageNumber - 1;

      const disabledClass = disabled ? 'disabled' : '';
      return (
          <>
              <i
                  className={`fa fa-solid fa-caret-left ${disabledClass}`}
                  onClick={() => !disabled && this.props.onPageChange && this.props.onPageChange(previousPage)}
              ></i>
              <CustomLabel
                  onClick={() => !disabled && this.props.onPageChange && this.props.onPageChange(previousPage)}
              >
                  Back
              </CustomLabel>
          </>
      );
      // return (
      //     <Pagination.Prev
      //         disabled={disabled}
      //         onClick={() => !disabled && this.props.onPageChange && this.props.onPageChange(previousPage)}
      //     />
      // );
  }

  get next() {
      const disabled = this.pagination.pageCount <= 0 || this.pagination.pageNumber === this.pagination.pageCount;

      const nextPage = this.pagination.pageNumber + 1;
      const disabledClass = disabled ? 'disabled' : '';
      return (
          <>
              <CustomLabel onClick={() => !disabled && this.props.onPageChange && this.props.onPageChange(nextPage)}>
                  Next
              </CustomLabel>
              <i
                  className={`fa fa-solid fa-caret-right ${disabledClass}`}
                  onClick={() => !disabled && this.props.onPageChange && this.props.onPageChange(nextPage)}
              ></i>
          </>
      );
      // return (
      //     <Pagination.Next
      //         disabled={disabled}
      //         onClick={() => !disabled && this.props.onPageChange && this.props.onPageChange(nextPage)}
      //     />
      // );
  }

  get first() {
      const disabled = this.pagination.pageCount <= 0 || this.pagination.pageNumber === 1;

      return (
          <Pagination.First
              disabled={disabled}
              onClick={() => !disabled && this.props.onPageChange && this.props.onPageChange(1)}
          />
      );
  }

  get last() {
      const disabled = this.pagination.pageCount <= 0 || this.pagination.pageNumber === this.pagination.pageCount;

      return (
          <Pagination.Last
              disabled={disabled}
              onClick={() =>
                  !disabled && this.props.onPageChange && this.props.onPageChange(this.pagination.pageCount)
              }
          />
      );
  }

  render() {
      // if (!this.pagination.pageCount || this.pagination.pageCount <= 1) return null;

      const pages = this.pagination.pageCount;
      return (
          <div>
              <PaginationWrapper className={this.props.className}>
                  <div>
                      <CustomLabel>
                          {' '}
                          <span className="highlighted-black">{this.pagination.totalItemCount}</span> records
                      </CustomLabel>
                  </div>
                  <Pagination>
                      <FlexContainer alignItems="center" spacing={10} className="pg-middle-section">
                          {this.previous}
                          <CustomLabel fontWeight={'600'} margin="0px 10px">
                              {pages > 0 ? `${this.pagination.pageNumber} - ${pages}` : '1'}
                          </CustomLabel>
                          {this.next}
                      </FlexContainer>
                      {/* {this.first} */}
                      {/* {this.previous} */}
                      {/* {this.paginationNumbering} */}
                      {/* {this.next} */}
                      {/* {this.last} */}
                  </Pagination>
                  <div>
                      <FlexContainer alignItems="center" spacing={5}>
                          <CustomLabel>Records per page</CustomLabel>
                          <div>
                              <SingleSelect
                                  selectedKey={this.pagination.pageSize}
                                  nameKeys={['label']}
                                  valueKeys={['value']}
                                  searchable={false}
                                  options={[this.options]}
                                  customHeader={<>{this.pagination.pageSize}</>}
                                  onChange={(options) =>
                                      this.props.onPageSizeChange && this.props.onPageSizeChange(options.value)
                                  }
                                  className="pg-single-select"
                              />
                          </div>
                      </FlexContainer>
                  </div>
              </PaginationWrapper>
          </div>
      );
  }
}
